import { useMemo } from "react";
import {
  availableColor,
  borderAvailableColor,
  noAvailableColor,
  unAssignColor,
} from "../constants";

export const useDroneUIState = ({ status, clickBox, boxValue }) => {
  return useMemo(() => {
    const isDroneAvailable = status === "Available";
    const isDroneUnavailable = status === "Unavailable";

    const baseColor = isDroneAvailable
      ? availableColor
      : isDroneUnavailable
      ? noAvailableColor
      : unAssignColor;

    const baseBorderColor = isDroneAvailable
      ? borderAvailableColor
      : isDroneUnavailable
      ? noAvailableColor
      : unAssignColor;

    const isSelected = Boolean(clickBox) && boxValue === status;

    return {
      isDroneAvailable,
      isDroneUnavailable,
      isSelected,
      color: isSelected ? "#ffffff" : baseColor,
      borderColor: isSelected ? baseColor : baseBorderColor,
      background: isSelected ? baseColor : "#ffffff",
      cursor: clickBox
        ? isSelected
          ? "default"
          : "pointer"
        : "default",
    };
  }, [status, clickBox, boxValue]);
};